import {
  NormalizedPoorSecurity,
  NormalizedSecurity,
} from '@swarm/types/normalized-entities/staking'
import { Security } from '@swarm/types/subgraph/graphql'

import { big } from '../helpers'

export const normalizeSecurity = (security: Security): NormalizedSecurity => {
  const token = security.token
  return {
    id: token.id,
    name: token.name,
    symbol: token.symbol,
    decimals: token.decimals,
    smtStaked: big(security.smtStaked),
    stakes: security.stakes,
  }
}

export const normalizePoorSecurity = (
  security: Security,
): NormalizedPoorSecurity => {
  const token = security.token
  return {
    id: token.id,
    name: token.name,
    symbol: token.symbol,
    decimals: token.decimals,
    smtStaked: big(security.smtStaked),
  }
}
